import { selectIssueById } from "@overmap-ai/core"
import { memo } from "react"

import { useAppSelector } from "../../store"
import { IssueTypeIcon } from "./IssueTypeIcon"
import type { LuIconWithWrapperProps } from "./LuIconWithWrapper"

interface IssueIconProps extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	issueId: string
}

/** @deprecated Use IssueTypeIcon instead with issue.issue_type **/
export const IssueIcon = memo<IssueIconProps>((props) => {
	const { ref, issueId, background = true, ...rest } = props

	const issue = useAppSelector(selectIssueById(issueId))

	if (!issue) {
		throw new Error(`Could not find issue ${issueId} for submission.`)
	}

	return <IssueTypeIcon ref={ref} issueTypeId={issue.issue_type} background={background} {...rest} />
})
IssueIcon.displayName = "IssueIcon"
